function LandingSectionContainer({ className, children }) {
  return (
    <section className={className}>
      <div className="max-w-screen-xl overflow-auto mx-auto px-10 py-21 mb:px-5 mb:py-12.5">{children}</div>
    </section>
  )
}

export default LandingSectionContainer
